<template>
  <modal
    name="confirmation"
    :clickToClose="false"
    @before-open="beforeOpen"
    height="auto"
    width="400"
  >
    <div class="confirmation-container" :class="params.variant">
      <hcc-confirmation-header
        :variant="params.variant"
        :title="params.title"
      />
      <div class="confirmation__description">{{ params.description }}</div>
    </div>
    <hcc-confirmation-footer
      :variant="params.variant"
      :handleConfirm="handleConfirm"
      :handleCancel="handleCancel"
    />
  </modal>
</template>

<script>
import HccConfirmationHeader from './HccConfirmationHeader.vue';
import HccConfirmationFooter from './HccConfirmationFooter.vue';

export default {
  components: {
    HccConfirmationFooter,
    HccConfirmationHeader,

  },
  data() {
    return {
      params: {},
    };
  },
  methods: {
    beforeOpen(event) {
      this.params = {
        cancel: () => {
        },
        confirm: () => {
        },
        ...(event.params || {}),
      };
    },
    handleConfirm() {
      this.params.confirm();
      this.$modal.hide('confirmation');
    },
    handleCancel() {
      this.params.cancel();
      this.$modal.hide('confirmation');
    },
  },

};
</script>

<style scoped lang="scss">
@import "~styles/shared/confirmation.scss";
</style>
